<template>
  <div class="page section">
    <div class="main_content">
      <div class="content_title">
        <div style="display: flex;flex-direction: column;">
          <p class="title white">更多资讯</p>
          <img src="../../assets/line.png" class="line" style="margin-top: 20px" alt="" />
          <p class="subtitle white">More news</p>
        </div>
        <div @click="goBack" class="tc" style="cursor: pointer;">
          <div class="blue">返回 ></div>
          <img src="../../assets/small_line.png" class="small_line" style="margin-top: 6px" alt="" />
        </div>
      </div>
      <div id="tabs">
        <el-tabs :tab-position="tabPosition" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="小鳗动态" name="1">
            <div class="title_item" v-for="item in list" :key="list.aid" @click="toDetail(item.aid)">
              <img src="../../assets/news/new_icon.png" />
              {{ item.title }}
            </div>
            <!-- <div  class="title_item" v-for="item in 100" >
            {{ item }}
          </div> -->
          </el-tab-pane>
          <el-tab-pane label="行业资讯" name="2">
            <div class="title_item" v-for="item in list" :key="list.aid" @click="toDetail(item.aid)">
              <img src="../../assets/news/new_icon.png" />

              {{ item.title }}
            </div>
          </el-tab-pane>
          <el-tab-pane label="小鳗课堂" name="3">
            <div class="title_item" v-for="item in list" :key="list.aid" @click="toDetail(item.aid)">
              <img src="../../assets/news/new_icon.png" />

              {{ item.title }}
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import anime from "animejs";

export default {
  name: "news",
  data () {
    return {
      currentScroll: 0,
      work: [],

      tabPosition: "left",
      direction: "rtl",
      type: 1,
      list: [],
      activeName: "1"
    };
  },

  created () {
    this.type = this.$route.query.type;
    this.activeName = this.type;

    this.getNew(this.type);
  },
  mounted () {
    window.scrollTo(0,0)
  },
  methods: {
    goBack () {
      this.$router.back();
    },
    handleClick (tab) {
      this.activeName = tab.name;
      this.type = tab.name;
      this.getNew(this.type);
      console.log("112313");
    },
    toDetail (id) {
      this.$router.push({
        path: "/newDetail/" + id + ".html"
      });
    },

    getNew (type) {
      var params = new URLSearchParams();
      params.append("start", 1);
      params.append("limit", 9999);
      params.append("type", type);
      this.$axios.post("/api/websiteNews/websiteList", params).then(res => {
        this.list = JSON.parse(JSON.stringify(res.data.data.records));
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../assets/style/more.scss';
.page {
  width: 100%;
  background: url('../../assets/news_bg.png') no-repeat;
  background-position: center;
  background-size: cover;
}

.content_title {
  display: flex;
  justify-content: space-between;
  padding-top: 100px;
  text-align: left;
  align-items: flex-end;
}

.title {
  font-size: 48px;
  font-family: 'PangMenZhengDao';
  font-weight: 400;
  letter-spacing: 6px;
}
.subtitle {
  font-size: 24px;
  font-family: 'PangMenZhengDao';
  font-weight: 400;
  margin-top: 20px;
}
#tabs {
  height: 490px;
  background: rgba(41, 46, 54, 0.60);
  margin-top: 60px;
}

//滚动条的宽度
::-webkit-scrollbar {
  width: 4px;
  height: 100%;
  background: #5c76a9;
  opacity: 0.2;
}

::-webkit-scrollbar-button {
  display: none;
}
// 滚动条的轨道（里面装有Thumb）
::-webkit-scrollbar-track {
  background: transparent;
}
// 滚动条的轨道（里面装有Thumb）
::-webkit-scrollbar-track-piece {
  background-color: transparent;
}
// 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
::-webkit-scrollbar-thumb {
  width: 8px !important;
  height: 100px;
  background: #3e4d6d;
  cursor: pointer;
  border-radius: 4px;
  z-index: 9;
}
/deep/ .el-tab-pane {
  /* background: #697; */
  height: 380px;
  overflow-y: auto;
}
/deep/ .el-tabs__header {
  padding-top: 60px;
}
/deep/ .el-tabs__content {
  padding-top: 60px;
  margin-left: 60px;
}
/deep/ .el-tabs--left .el-tabs__nav-wrap.is-left::after {
  width: 0 !important;
}
/deep/ .el-tabs__item:hover {
  background: linear-gradient(to right, rgba(49, 112, 255, 0.3), #283040);
  /* border-left: 4px solid #3170ff !important; */
}
/deep/ .el-tabs__active-bar {
  background: transparent !important;
}
/deep/ .el-tabs__item {
  text-align: left !important;
  padding: 0 40px !important;
  width: 200px;
  height: 42px;
  line-height: 42px;
  font-size: 16px;
  color: #fff;
  border-left: 4px solid transparent !important;
}
>>> .el-tabs__item.is-active {
  background: linear-gradient(
    to right,
    rgba(49, 112, 255, 0.3),
    #283040
  ) !important;
  border-left: 4px solid #3170ff !important;
}
.title_item {
  width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
  height: 48px;
  text-align: left;
  line-height: 48px;
  color: #ffffff;
  font-size: 16px;
  font-family: 'Regular';
  font-weight: 400;
  color: #fdfeff;
  border-bottom: 1px solid;
  border-image: linear-gradient(
      to right,
      #6b6767 rgba(255, 255, 255, 0.3),
      rgba(82, 123, 217, 0.07)
    )
    1 10 10;
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    margin-right: 10px;
    width: 16px;
    height: 16px;
  }
}

.title_item:hover {
  /* text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  background: linear-gradient(to right, #3170ff, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; */
  background: linear-gradient(
    to right,
    rgba(49, 112, 255, 0.3) 20%,
    #283040 70%
  ) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/page/more.vue